import { Breadcrumb as AntdBreadcrumb } from 'antd'
import styled from 'styled-components'

const Breadcrumb = styled(AntdBreadcrumb)`
  padding: 8px 0 0 0;
`

export default Breadcrumb
